import createApiClient from "./createApiClient";

const atmoClient = createApiClient(import.meta.env.VITE_APP_BACK_URL);

export default atmoClient;
export { atmoClient };
